import {isStaffPath} from '../shared/staff-workspaces';
import {patientEntry} from './screens/home/patientEntry';
// The app's front door is the rebuilt Home (/home). Root scan/chat links open its
// matching place; embedded compatibility cards keep their existing engine.

/** The address of the chat. */
export const CHAT = '/?chat=1';

/** Known legacy URLs preserve their intent in the current app; unknown patient paths go Home. */
export function frontDoor(path:string,search:string,hash=''):string|null {
  if(isStaffPath(path))return null;
  if(['/photos-demo','/test/voice','/test/bridge-session'].includes(path.replace(/\/+$/,'')))return '/home';
  const next=patientEntry(path,search,hash).href;
  return path+search+hash===next?null:next;
}

/** The chat's address after it removes a query: never the bare "/", which would open Home on reload. */
export function chatAddress(url: URL): string {
  if (url.pathname === '/' && !url.search) url.searchParams.set('chat', '1');
  return url.pathname + url.search + url.hash;
}

